"use client";

import { useEffect, useState } from "react";
import { preload } from 'react-dom';
import ENDPOINTS from "../constants/apis/endpoints";
import microCmsGetAuth from "../constants/apis/microCmsGetApiKey";
import useFetchContentsForHome from "../hooks/useFetchContentsForHome.hooks";
import useFetchVoicesForHome from "../hooks/useFetchVoicesForHome.hooks";
import { microCmsAuthType } from "../types/microCmsAuthType";
import { ContentsListHookResponseType } from "../types/microCmsHookResponseTypes";
import HomeBlog from "./_home/HomeBlog/HomeBlog";
import HomeMainView from "./_home/HomeMainView/HomeMainView";
import HomeNews from "./_home/HomeNews/HomeNews";
import HomeOurService from "./_home/HomeOurService/HomeOurService";
import HomeVoice from "./_home/HomeVoice/HomeVoice";
import Manifest from "./_home/Manifest/Manifest";

const Home = () => {
  preload("/images/home/mv.webp", {
    as: "image",
  });
  preload("/images/home/mv_sp.webp", {
    as: "image",
  });
  const endpoints = ENDPOINTS;

  const [response, setResponse] = useState<ContentsListHookResponseType>();
  const [voiceResponse, setVoiceResponse] = useState<any>();
  const [flashInformationResponse, setFlashInformationResponse] = useState<any>();
  useEffect(()=> {
    const FetchData = async() => {

      // フック用クエリ情報を定数から取得
      const q_plt_HomeQueries = {"info": {"endpointId": endpoints["news"].ID, "limit": 3}, "blog": {"endpointId": endpoints["blog"].ID, "limit": 3}}
      const voiceHomeRequestQuery = {"endpointId": endpoints["voice"].ID, "limit": 5};

      const microCMSAuth: microCmsAuthType = microCmsGetAuth;
      // お知らせとブログの取得フック
      const homeContents = await useFetchContentsForHome(microCMSAuth, q_plt_HomeQueries);
      // console.log("homeContents: " + JSON.stringify(homeContents));  //debug;

      setResponse(homeContents);

      // MV下のお知らせを設定

      const category = homeContents?.responseBody["news"]?.contents[0].category[0];
      const categorySlug = category === "セミナー情報" ? "seminar" : category === "NEWS" ? "news" : "";

      const flashInformation = {
        id: "FlashInformation",
        flashTitle: {text: "news"},
        articleDate: {date: homeContents?.responseBody["news"]?.contents[0].publishedAt},
        articleTitle: {text: homeContents?.responseBody["news"]?.contents[0].title},
        url: `/${ENDPOINTS["news"].ID}/post/?id=${homeContents?.responseBody["news"]?.contents[0].id || ""}`
      };
      setFlashInformationResponse(flashInformation);

      // お客様の声取得フック
      const voiceContents = await useFetchVoicesForHome(microCMSAuth, voiceHomeRequestQuery)
      // console.log("voiceContents: " + JSON.stringify(voiceContents));  // debug
      setVoiceResponse(voiceContents.responseBody.contents)
    }
    FetchData();
  }, [endpoints]);

  return (
    <>
      <HomeMainView flashInformation={flashInformationResponse} />
      <Manifest />
      <HomeOurService />
      <HomeVoice voiceResponse={voiceResponse} />
      <HomeNews response={response} />
      <HomeBlog response={response} />
    </>
  )
}

export default Home;